'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _ObjectStoreBaseApi = require('./ObjectStoreBaseApi');
var _ObjectStoreBaseApi2 = _interopRequireDefault(_ObjectStoreBaseApi);
var _BaseApi = require('../BaseApi');
var _BaseApi2 = _interopRequireDefault(_BaseApi);
var _frontendUtils = require('@import/frontend-utils');
var _validationUtils = require('@import/validation-utils');
var ValidationUtils = _interopRequireWildcard(_validationUtils);
var _ParameterError = require('../ParameterError');
var _ParameterError2 = _interopRequireDefault(_ParameterError);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ExtractorApi = function () {
  function ExtractorApi() {
    (0, _classCallCheck3.default)(this, ExtractorApi);
    this.apiService = new _BaseApi2.default(_frontendUtils.endpoints.apiBaseUrl);
    this.storeService = new _ObjectStoreBaseApi2.default(_frontendUtils.endpoints.storeBaseUrl, 'extractor');
  }
  (0, _createClass3.default)(ExtractorApi, [{
    key: 'getExtractorData',
    value: function getExtractorData() {
      var extractorGuid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (extractorGuid && !ValidationUtils.isGuid(extractorGuid)) {
        return Promise.reject(new _ParameterError2.default('extractorGuid', extractorGuid, 'guid string.'));
      }
      return this.apiService.makeRequest({
        method: 'GET',
        url: 'maestro/extractor/' + extractorGuid
      });
    }
  }, {
    key: 'duplicate',
    value: function duplicate(extractorGuid) {
      if (!ValidationUtils.isGuid(extractorGuid)) {
        return Promise.reject(new _ParameterError2.default('extractorGuid', extractorGuid, 'guid string.'));
      }
      return this.apiService.makeRequest({
        method: 'POST',
        url: 'extractor/' + extractorGuid,
        retryMax: 1
      });
    }
  }, {
    key: 'createWithConfig',
    value: function createWithConfig(value) {
      if (!ValidationUtils.isObject(value)) {
        return Promise.reject(new _ParameterError2.default('value', value, 'javascript object.'));
      }
      return this.apiService.makeRequest({
        method: 'POST',
        url: 'extractor',
        body: value,
        retryMax: 1
      });
    }
  }, {
    key: 'run',
    value: function run(extractorGuid, params) {
      if (!ValidationUtils.isGuid(extractorGuid)) {
        return Promise.reject(new _ParameterError2.default('extractorGuid', extractorGuid, 'guid string.'));
      }
      return this.apiService.makeRequest({
        method: 'POST',
        url: 'maestro/extractor/' + extractorGuid,
        body: params
      });
    }
  }, {
    key: 'getCrawlRuns',
    value: function getCrawlRuns(extractorGuid) {
      if (!ValidationUtils.isGuid(extractorGuid)) {
        return Promise.reject(new _ParameterError2.default('extractorGuid', extractorGuid, 'guid string.'));
      }
      return this.apiService.makeRequest({
        method: 'GET',
        url: 'maestro/extractor/' + extractorGuid + '/crawlRun'
      });
    }
  }, {
    key: 'getLatestCrawl',
    value: function getLatestCrawl(extractorGuid) {
      if (!ValidationUtils.isGuid(extractorGuid)) {
        return Promise.reject(new _ParameterError2.default('extractorGuid', extractorGuid, 'guid string.'));
      }
      return this.apiService.makeRequest({
        method: 'GET',
        url: 'maestro/extractor/' + extractorGuid + '/crawlRun/latest'
      });
    }
  }, {
    key: 'getLatestData',
    value: function getLatestData(extractorGuid) {
      if (!ValidationUtils.isGuid(extractorGuid)) {
        return Promise.reject(new _ParameterError2.default('extractorGuid', extractorGuid, 'guid string.'));
      }
      return this.apiService.makeRequest({
        method: 'GET',
        url: 'maestro/extractor/' + extractorGuid + '/crawlRun/latest/data'
      });
    }
  }]);
  return ExtractorApi;
}();
exports.default = ExtractorApi;